module.exports = __webpack_public_path__ + "media/images/icons/chat-dots-8ddcdad00d789e9aca9f6f39768fba9a.svg";